import React, { useEffect, useState, useCallback } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Outlet } from "react-router-dom";
import { Layout } from "antd";

import AdminHeader from "./AdminHeader/AdminHeader";
import Sidebar from "./Sidebar";

const { Content } = Layout;

const MainLayout = () => {
    const [collapsed, setCollapsed] = useState(false);

    const updateCollapsed = useCallback((isCollapsed) => {
        setCollapsed(isCollapsed);
    }, []);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 768) {
                setCollapsed(true);
            }
        };

        window.addEventListener("resize", handleResize);
        handleResize();
        return () => window.removeEventListener("resize", handleResize);
    }, []);


    return (
        <Layout>
            <Sidebar collapsed={collapsed} />
            <Layout className="site-layout">
                <AdminHeader collapsed={collapsed} setCollapsed={updateCollapsed} />
                <Content
                    style={{
                        padding: '24px',
                        minHeight: '280px',
                    }}
                >
                    <ToastContainer
                        position="top-right"
                        autoClose={250}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        theme="light"
                    />
                    <Outlet />
                </Content>
            </Layout>
        </Layout>
    );
};

export default MainLayout;
